import { Injectable } from "@angular/core";
import { Province } from "../models/category";

@Injectable({
  providedIn: "root"
})
export class GlobalStateService {
  public provinces: Province[] = [];

  public get provincesID(): string[] {
    return this.provinces.map(p => p._id);
  }
}